import { pageApi } from 'container/pageApi';
import { PageRepository } from 'repository/PageRepository';

export const pageRepository: PageRepository = new PageRepository(pageApi);
